<template>
  <MainLayout>
    <template v-slot:toolbar>
      <!--begin::Page title-->
      <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
        <!--begin::Title-->
        <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">{{ pageTitle }}</h1>
        <!--end::Title-->
      </div>
      <!--end::Page title-->
      <!--begin::Actions-->
      <div class="d-flex align-items-center gap-2 gap-lg-3 position-relative">
        <!--begin::Filter menu-->
        <div class="m-0">
          <!--begin::Menu toggle-->
          <a
            href="#"
            @click.prevent="isFiltersOpen = !isFiltersOpen"
            class="btn btn-sm btn-flex bg-body btn-color-gray-700 btn-active-color-primary fw-bold"
          >
            <!--begin::Svg Icon | path: icons/duotune/general/gen031.svg-->
            <span class="svg-icon svg-icon-6 svg-icon-muted me-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z" fill="currentColor" />
            </svg>
          </span>
            <!--end::Svg Icon-->Filtrar</a>
          <!--end::Menu toggle-->
          <!--begin::Menu 1-->
          <div
            class="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
            :class="{
              'show': isFiltersOpen
            }"
            style="position: absolute; top: 40px; right: 0;"
          >
            <!--begin::Header-->
            <div class="px-7 py-5">
              <div class="fs-5 text-dark fw-bold">Opções de Filtro</div>
            </div>
            <!--end::Header-->
            <!--begin::Menu separator-->
            <div class="separator border-gray-200"></div>
            <!--end::Menu separator-->
            <!--begin::Form-->
            <div class="px-7 py-5">
              <!--begin::Input group-->
              <div class="mb-5">
                <!--begin::Label-->
                <label class="form-label fw-semibold">Busca:</label>
                <p style="font-size: 11px;">(Número da nota, identificador do pagamento, empresa, anunciante)</p>
                <!--end::Label-->
                <!--begin::Input-->
                <div>
                  <input type="text" class="form-control form-control-solid" placeholder="" v-model.trim="filters.search"/>
                </div>
                <!--end::Input-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="mb-5">
                <!--begin::Label-->
                <label class="form-label fw-semibold">Status da NF:</label>
                <!--end::Label-->
                <!--begin::Input-->
                <div>
                  <select class="form-select" aria-label="Select example" v-model="filters.status">
                    <option value="">Todos</option>
                    <option value="WAITING">Aguardando emissão</option>
                    <option value="ISSUED">Emitido</option>
                    <option value="CANCELED">Cancelado</option>
                  </select>
                </div>
                <!--end::Input-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="mb-5">
                <!--begin::Label-->
                <label class="form-label fw-semibold">Data de emissão:</label>
                <!--end::Label-->
                <!--begin::Input-->
                <div>
                  <div class="d-flex align-items-start justify-content-between">
                    <div class="">
                      <input class="form-control form-control-solid date_picker_date" v-model.trim="filters.start_date" />
                      <div class="mt-3">
                        <button type="button" class="btn btn-sm btn-primary" @click="filters.start_date = ''" v-if="filters.start_date">Limpar</button>
                      </div>
                    </div>
                    <div class="px-4 mt-4">-</div>
                    <div class="">
                      <input class="form-control form-control-solid date_picker_date" v-model.trim="filters.end_date" />
                      <div class="mt-3">
                        <button type="button" class="btn btn-sm btn-primary" @click="filters.end_date = ''" v-if="filters.end_date">Limpar</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--end::Input-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="mb-5">
                <!--begin::Label-->
                <label class="form-label fw-semibold">Status da aprovação:</label>
                <!--end::Label-->
                <!--begin::Input-->
                <div>
                  <select class="form-select" aria-label="Select example" v-model="filters.nfse_approval">
                    <option value="">Todos</option>
                    <option value="APPROVED">Aprovado</option>
                    <option value="PENDING">Pendente</option>
                    <option value="REFUSED">Recusado</option>
                  </select>
                </div>
                <!--end::Input-->
              </div>
              <!--end::Input group-->
              <!--begin::Input group-->
              <div class="mb-5">
                <!--begin::Label-->
                <label class="form-label fw-semibold">Forma de pagamento:</label>
                <!--end::Label-->
                <!--begin::Input-->
                <div>
                  <select class="form-select" aria-label="Select example" v-model="filters.payment_method">
                    <option value="">Todos</option>
                    <option value="BOLETO">Boleto</option>
                    <option value="CREDIT_CARD">Cartão de Crédito</option>
                    <option value="DEPOSIT">Depósito</option>
                    <option value="PIX">PIX</option>
                  </select>
                </div>
                <!--end::Input-->
              </div>
              <!--end::Input group-->
              <!--begin::Actions-->
              <div class="d-flex justify-content-end">
                <button type="reset" class="btn btn-sm btn-light btn-active-light-primary me-2" data-kt-menu-dismiss="true" @click="reset">Resetar</button>
                <button type="submit" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true" @click="applyFilters">Aplicar</button>
              </div>
              <!--end::Actions-->
            </div>
            <!--end::Form-->
          </div>
          <!--end::Menu 1-->
        </div>
        <!--end::Filter menu-->
        <!--begin::Secondary button-->
        <!--end::Secondary button-->
      </div>
      <!--end::Actions-->
    </template>

    <!-- CONTENT -->
    <!--begin::Products-->
    <div class="card card-flush">
      <!--begin::Card body-->
      <div class="card-body pt-0">
        <template v-if="loader && invoices.length === 0">
          <div class="py-5">
            <Loader size="big" />
          </div>
        </template>
        <template v-else>
          <!--begin::Table-->
          <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_ecommerce_products_table">
            <!--begin::Table head-->
            <thead>
            <!--begin::Table row-->
            <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
              <th class="min-w-100px">ID do pagamento</th>
              <th class="min-w-70px">Anunciante</th>
              <th class="min-w-100px">Status da nota</th>
              <th class="min-w-70px">Valor da nota</th>
              <th class="min-w-70px">Data de emissão</th>
              <th class="min-w-100px">Número da nota</th>
              <th class="min-w-100px">Forma de pagamento</th>
              <th class="min-w-100px">Status do pagamento</th>
              <th class="min-w-100px">Status aprovação NF</th>
              <th class="min-w-100px">Ações</th>
            </tr>
            <!--end::Table row-->
            </thead>
            <!--end::Table head-->
            <!--begin::Table body-->
            <tbody class="fw-semibold text-gray-600">
            <!--begin::Table row-->
            <tr v-for="(invoice, index) in invoices" :key="index">
              <td>
                <span>{{ invoice.order.identifier }}</span>
              </td>
              <td>
                <span>
                  <router-link :to="{ name: 'advertisers.show', params: { id: invoice.order.advertiser.id } }">
                    {{ invoice.order.advertiser.name }}
                  </router-link>
                </span>
              </td>
              <td>
                <span>{{ invoice.nfse_status | formatNFSeStatus }}</span>
              </td>
              <td>
                <span>{{ invoice.nfse_amount / 100 | formatMoney(invoice.order.advertiser.currency) }}</span>
              </td>
              <td>
                <span>{{ invoice.nfse_issuance_date | formatDate }}</span>
              </td>
              <td>
                <span>{{ invoice.nfse_number ?? '---' }}</span>
              </td>
              <td>
                <span>{{ invoice.payment_method | formatPaymentMethod }}</span>
              </td>
              <td class=" pe-0">
                <span>{{ invoice.payment_status | formatPaymentStatus }}</span>
              </td>
              <td>
                <span>{{ invoice.is_nfse_approved | formatNFSeApprovalStatus }}</span>
              </td>
              <td>
                <div class="d-flex">
                  <Button
                    class="btn btn-sm btn-primary"
                    v-b-modal="`order-detail-modal-${invoice.order.id}`"
                  >
                    <i class="fas fa-eye px-0"></i>
                  </Button>
                  <Button
                    class="btn btn-sm btn-info ms-2"
                    v-b-modal="`approve-order-${invoice.order.id}-nfse-modal`"
                    v-if="!invoice.is_nfse_approved && invoice.nfse_status === 'WAITING'"
                  >
                    <i class="fas fa-magnifying-glass px-0"></i>
                  </Button>
                </div>
                <ApproveOrderNFSeModal
                  :orderId="invoice.order.id"
                  v-if="!invoice.is_nfse_approved"
                />
                <OrderDetailModal
                  :orderId="invoice.order.id"
                />
              </td>
            </tr>
            <!--end::Table row-->
            </tbody>
            <!--end::Table body-->
          </table>
          <!--end::Table-->
          <div class="text-center py-5">
            <Button
              class="btn-primary"
              :loading="loader"
              @click="loadMore"
              v-if="isLoadMoreVisible"
            >
              Carregar mais
            </Button>
          </div>
        </template>
      </div>
      <!--end::Card body-->
    </div>
    <!--end::Products-->
    <!-- END CONTENT -->
  </MainLayout>
</template>

<script>

import InvoicesService from '@/modules/invoices/services/invoices-service'

import ApproveOrderNFSeModal from '@/components/orders/ApproveOrderNFSeModal'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import OrderDetailModal from '@/components/orders/OrderDetailModal'

export default {
  components: {
    ApproveOrderNFSeModal,
    Button,
    Loader,
    MainLayout,
    OrderDetailModal
  },
  metaInfo () {
    return {
      title: 'Notas fiscais'
    }
  },
  data () {
    return {
      filters: {
        end_date: '',
        nfse_approval: '',
        payment_method: '',
        start_date: '',
        search: '',
        status: ''
      },
      isFiltersOpen: false,
      isLoadMoreVisible: false,
      invoices: [],
      loader: false,
      loaderPayment: [],
      page: 1
    }
  },
  created () {
    this.filters.nfse_approval = this.$route.query.nfse_approval || ''
    this.getInvoices()
  },
  mounted () {
    document.getElementsByClassName('date_picker_date').forEach(item => {
      item.flatpickr({
        dateFormat: 'd/m/Y'
      })
    })
  },
  watch: {
    '$route.query.nfse_approval' (value) {
      this.filters.nfse_approval = value
      this.applyFilters()
    }
  },
  computed: {
    /**
     * Page title
     */
    pageTitle () {
      switch (this.$route.name) {
        case 'invoices.index':
          return 'Pagamentos pendentes'
        case 'nfse.index':
          return 'Notas fiscais'
        default:
          return ''
      }
    }
  },
  methods: {
    /**
     * Apply filters and search
     */
    applyFilters () {
      this.isFiltersOpen = false
      this.page = 1
      this.invoices = []
      this.getInvoices()
    },
    /**
     * Get invoices
     */
    async getInvoices () {
      this.loader = true
      try {
        const invoices = await InvoicesService.getInvoices({
          nfseApproval: this.filters.nfse_approval,
          nfseStatus: this.filters.status ? [this.filters.status] : ['WAITING', 'CANCELED', 'PENDING', 'ISSUED'],
          nfseIssuanceDateStart: this.filters.start_date,
          nfseIssuanceDateEnd: this.filters.end_date,
          search: this.filters.search,
          page: this.page,
          paymentMethod: this.filters.payment_method,
          orderBy: 'nfse_issuance_date'
        })
        this.invoices = [...this.invoices, ...invoices.data]
        this.isLoadMoreVisible = invoices.meta.current_page !== invoices.meta.last_page
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Load more
     */
    loadMore () {
      this.page++
      this.getInvoices()
    },
    reset () {
      this.page = 1
      this.invoices = []
      this.filters.search = ''
      this.filters.end_date = ''
      this.filters.payment_method = ''
      this.filters.start_date = ''
      this.filters.search = ''
      this.filters.nfse_approval = ''
      this.isFiltersOpen = false
      this.getInvoices()
    }
  }
}
</script>
